module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_9005.914d0fb0.png";